import { SxProps, Theme } from '@mui/material';

const detailContainer: SxProps<Theme> = (theme) => ({
  display: 'flex',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(3.75),
  alignItems: 'center',
});

const chartsContainer: SxProps<Theme> = () => ({
  canvas: {
    minHeight: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    height: 'auto!important',
    width: 'auto!important',
  },
});

const submittedCheckinsDetailsContainer: SxProps<Theme> = () => ({
  '@media print': {
    marginTop: 15,
  },
});

const styles = {
  detailContainer,
  chartsContainer,
  submittedCheckinsDetailsContainer,
};

export default styles;
